'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var MOBILE_APP_BALANCE_ACTIVE_CURRENCY_UPDATED = 'mobile-app:active-currency-updated';
var MOBILE_APP_MESSAGE_MARK_AS_READ = 'mobile-app:message-mark-as-read';

exports.MOBILE_APP_BALANCE_ACTIVE_CURRENCY_UPDATED = MOBILE_APP_BALANCE_ACTIVE_CURRENCY_UPDATED;
exports.MOBILE_APP_MESSAGE_MARK_AS_READ = MOBILE_APP_MESSAGE_MARK_AS_READ;
